import React from 'react'

export default function MetricCard({ title, value, icon: Icon, trend, trendUp }) {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-sm)',
      padding: '20px 24px',
      border: '1px solid var(--color-border)',
      transition: 'box-shadow 0.2s, transform 0.2s',
      cursor: 'default'
    }}
    onMouseEnter={(e) => { e.currentTarget.style.boxShadow = 'var(--shadow-lg)'; e.currentTarget.style.transform = 'translateY(-2px)' }}
    onMouseLeave={(e) => { e.currentTarget.style.boxShadow = 'var(--shadow-sm)'; e.currentTarget.style.transform = 'translateY(0)' }}
    >
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '8px'
      }}>
        <h3 style={{
          fontSize: '12px',
          fontWeight: '600',
          color: 'var(--color-text-muted)',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          margin: '0 0 8px 0'
        }}>
          {title}
        </h3>
        {Icon && (
          <Icon style={{
            width: '20px',
            height: '20px',
            color: 'var(--color-text-muted)'
          }} />
        )}
      </div>

      {/* Value */}
      <div style={{
        fontSize: '28px',
        fontWeight: '700',
        color: 'var(--color-text-primary)',
        letterSpacing: '-0.02em',
        marginBottom: trend ? '4px' : '0'
      }}>
        {value}
      </div>

      {/* Trend */}
      {trend && (
        <p style={{
          fontSize: '12px',
          color: trendUp ? '#059669' : '#dc2626',
          margin: 0
        }}>
          {trend}
        </p>
      )}
    </div>
  )
}
